<template>
    <svg aria-hidden="true" width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="11" y="14" width="11" height="14" rx="0.638889" transform="rotate(-180 11 14)" fill="#5FA37C" />
        <rect x="24" y="14" width="11" height="14" rx="0.638889" transform="rotate(-180 24 14)" fill="#BEE59F" />
    </svg>
</template>
